<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formGroupName="loan">
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      (onChange)="onDiffereChange(event)"
                      [toggleBgEmpty]="true"
                      formControlName="differe"
                      label="Type de différé"
                      [options]="[
                        {
                          value: 'AUCUN',
                          label: 'Aucun',
                        },
                        {
                          value: 'PARTIEL',
                          label: 'Partiel',
                        },
                        {
                          value: 'TOTAL',
                          label: 'Total',
                        },
                      ]"
                    >
                    </pr-input-radio>
                  </div>
                </div>
                @if (
                  form.get('products').value[0].parameters.loan.differe !==
                  'AUCUN'
                ) {
                  <div class="row">
                    <div class="col-md-12">
                      <pr-input-column
                        label="Durée du différé"
                        [derrors]="derrors"
                        [suffix]="'mois'"
                      >
                        <input
                          formControlName="durationDiffereInMonth"
                          type="text"
                          placeholder="120"
                        />
                      </pr-input-column>
                    </div>
                  </div>
                }
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
